import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { ProfileRoutingModule } from './profile-routing.module';
import { ProfileComponent } from './profile.component';
import { BasicInfoComponent } from './basic-info/basic-info.component';
import { SellerProfileComponent } from './basic-info/seller-profile/seller-profile.component';
import { AdminProfileComponent } from './basic-info/admin-profile/admin-profile.component';
import { PamProfileComponent } from './basic-info/pam-profile/pam-profile.component';
import { RolesDescriptionComponent } from './basic-info/roles-description/roles-description.component';
import { MessageModule } from '../shared/message/message.module';
import { ProfileMaterialModule } from './profile-material/profile-material.module';
import { TaxInfoComponent } from './tax-info/tax-info.component';
import { TaxInfoW9Component } from './tax-info-w9/tax-info-w9.component';
import { SharedModule } from '../shared';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    ProfileComponent,
    BasicInfoComponent,
    SellerProfileComponent,
    AdminProfileComponent,
    PamProfileComponent,
    TaxInfoComponent,
    TaxInfoW9Component,
    RolesDescriptionComponent
  ],
  imports: [
    CommonModule,
    ProfileRoutingModule,
    ProfileMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    MessageModule,
    SharedModule,
    TranslateModule,
  ]
})
export class ProfileModule { }
